/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import './scss/main.scss';
import './scss/basketPage.scss';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app_ = createApp(App);
app_.use(ElementPlus);
app_.mount('#app');
